import React from 'react';

class Footer extends React.Component {
  render() {
    return (
      <footer className="page-footer green darken-4">
        <div className="footer-copyright">
          &copy; 2017 Tecnologico de Cuautla
        </div>
      </footer>
      );
  }
}

export default Footer;


// WEBPACK FOOTER //
// ./src/components/Footer.js